import { ItemsContainerWebglSettingsConverter } from "./items-container-webgl-settings-converter";

export class PanelWebglSettingsConverter extends ItemsContainerWebglSettingsConverter {
  constructor(viewObjectConverters) {
    super(viewObjectConverters);
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    if (settings.items !== undefined && this.viewObjectConverters !== undefined && this.viewObjectConverters.size > 0) {
      settingsCopy.items = [];
      for (let itemIndex = 0; itemIndex < settings.items.length; itemIndex++) {
        let convertedItemSettings = this._copyItem(settings.items[itemIndex]);
        if (convertedItemSettings !== undefined) {
          settingsCopy.items.push(convertedItemSettings);
        }
      }
    }
    return settingsCopy;
  }
}
